import React from 'react';

import { SORT_ORDER } from '../../constants';
import DownCaretIcon from '../Icons/DownCaretIcon';
import UpCaretIcon from '../Icons/UpCaretIcon';

type Props = {
  sortOrder: any;
};

const SorterIcon = ({ sortOrder }: Props) => {
  if (sortOrder === SORT_ORDER.ASCEND) {
    return <DownCaretIcon />;
  } else if (sortOrder === SORT_ORDER.DESCEND) {
    return <UpCaretIcon />;
  }
  return <div />;
};

export default SorterIcon;
